// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"f36a84c0","453":"7b4d83ba","454":"beee8577","898":"17233aeb"}[chunkId] + ".chunk.js";
};